import { SortType } from '@/models/SortType';
import { Store } from 'vuex';

export function useSortDataClientSide() {
  /**
   * Trie les donn�es c�t� client au lieu de recharger depuis le serveur
   * @param store Instance du store Vuex
   * @param sortData Champ de tri
   * @param sortStatus Type de tri (ASC, DESC, NONE)
   * @param getterName Nom du getter pour r�cup�rer les �l�ments
   * @param mutationName Nom de la mutation pour mettre � jour les �l�ments
   */
  const sortDataClientSide = (
    store: Store<any>,
    sortData: string,
    sortStatus: SortType,
    getterName: string,
    mutationName: string
  ) => {
    if (sortStatus === SortType.NONE) {
      // Si le tri est r�initialis�, nous n'avons pas besoin de trier les donn�es
      return;
    }

    // R�cup�rer les �l�ments actuels du store
    const items = [...store.getters[getterName]];

    // Trier les �l�ments en fonction du champ et de la direction de tri
    items.sort((a, b) => {
      let valueA, valueB;

      // Traitement sp�cial pour le champ site d�riv� de adresseSite ou libelleExterneProjet
      if (sortData === 'site') {
        valueA = a.adresseSite ? a.adresseSite : a.libelleExterneProjet;
        valueB = b.adresseSite ? b.adresseSite : b.libelleExterneProjet;
        valueA = String(valueA ?? '').toLowerCase().trim();
        valueB = String(valueB ?? '').toLowerCase().trim();
      } else {
        valueA = a[sortData];
        valueB = b[sortData];

        // Traitement sp�cial pour les champs de date
        if (sortData === 'dateFacture' || sortData === 'dateEcheance') {
          valueA = valueA ? new Date(valueA).getTime() : 0;
          valueB = valueB ? new Date(valueB).getTime() : 0;
        }
        // Traitement des champs num�riques
        else if (typeof valueA === 'number' && typeof valueB === 'number') {
          // Pas de conversion n�cessaire
        }
        // Traitement des champs de type cha�ne (comparaison insensible � la casse)
        else {
          valueA = String(valueA ?? '').toLowerCase();
          valueB = String(valueB ?? '').toLowerCase();
        }
      }

      // D�terminer la direction de tri
      if (sortStatus === SortType.ASC) {
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      } else {
        return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
      }
    });

    // Mettre � jour le store avec les �l�ments tri�s
    store.commit(mutationName, items);
  };

  return {
    sortDataClientSide
  };
}
